// extracted by mini-css-extract-plugin
export default {"footer":"footer__Ou9n2","text":"text__5+9V3","copyright":"copyright__p+Cjz","footerBtn":"footerBtn__4XpQl","social":"social__QIEH8"};